import React from "react";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Error404 from "./Error404"
import Home from "./Home";
import Menu from "./Menu";
import CssSyntaxAndSelectors from "./css-tutorial-pages/CssSyntaxAndSelectors";
import CssInserting from "./css-tutorial-pages/CssInserting";
import CssColors from "./css-tutorial-pages/CssColors";
import CssBackgrounds from "./css-tutorial-pages/CssBackgrounds";
import CssBorders from "./css-tutorial-pages/CssBorders";
import CssMargins from "./css-tutorial-pages/CssMargins";
import CssPadding from "./css-tutorial-pages/CssPadding";
import CssWidthAndHeight from "./css-tutorial-pages/CssWidthAndHeight";
import CssBoxModels from "./css-tutorial-pages/CssBoxModels";
import CssText from "./css-tutorial-pages/CssText";
import CssFonts from "./css-tutorial-pages/CssFonts";
import CssIcons from "./css-tutorial-pages/CssIcons";
import CssLinks from "./css-tutorial-pages/CssLinks";
import CssLists from "./css-tutorial-pages/CssLists";
import CssTables from "./css-tutorial-pages/CssTables";
import CssOutline from "./css-tutorial-pages/CssOutline";
import CssButtons from "./css-tutorial-pages/CssButtons";
import CssImages from "./css-tutorial-pages/CssImages";
import CssLayoutTheDisplayProperty from "./css-tutorial-pages/CssLayoutTheDisplayProperty";
import CssLayoutWidthAndMaxWidth from "./css-tutorial-pages/CssLayoutWidthAndMaxWidth";
import CssLayoutPositioning from "./css-tutorial-pages/CssLayoutPositioning";
import CssLayoutOverflow from "./css-tutorial-pages/CssLayoutOverflow";
import CssLayoutFloatAndClear from "./css-tutorial-pages/CssLayoutFloatAndClear";
import CssLayoutInlineBlock from "./css-tutorial-pages/CssLayoutInlineBlock";
import CssLayoutHorizontalAndVerticalAlign from "./css-tutorial-pages/CssLayoutHorizontalAndVerticalAlign";
import CssCombinators from "./css-tutorial-pages/CssCombinators";
import CssPseudoClasses from "./css-tutorial-pages/CssPseudoClasses";
import CssPseudoElements from "./css-tutorial-pages/CssPseudoElements";
import CssAttributeSelectors from "./css-tutorial-pages/CssAttributeSelectors";
import CssOpacity from "./css-tutorial-pages/CssOpacity";
import Css3Introduction from "./css-tutorial-pages/Css3Introduction";
import Css3RoundedCorners from "./css-tutorial-pages/Css3RoundedCorners";
import Css3BorderImages from "./css-tutorial-pages/Css3BorderImages";
import Css3Colors from "./css-tutorial-pages/Css3Colors";
import Css3Backgrounds from "./css-tutorial-pages/Css3Backgrounds";
import Css3Gradients from "./css-tutorial-pages/Css3Gradients";
import Css3ShadowEffects from "./css-tutorial-pages/Css3ShadowEffects";
import Css3Text from "./css-tutorial-pages/Css3Text";
import Css3WebFonts from "./css-tutorial-pages/Css3WebFonts";
import Css32dTransforms from "./css-tutorial-pages/Css32dTransforms";
import Css33dTransforms from "./css-tutorial-pages/Css33dTransforms";
import Css3Transitions from "./css-tutorial-pages/Css3Transitions";
import Css3Animations from "./css-tutorial-pages/Css3Animations";
import Css3MultipleColumns from "./css-tutorial-pages/Css3MultipleColumns";
import Css3UserInterface from "./css-tutorial-pages/Css3UserInterface";
import Css3BoxSizing from "./css-tutorial-pages/Css3BoxSizing";
// import Css3FlexibleBoxes from "./css-tutorial-pages/Css3FlexibleBoxes";
// import Css3MediaQueries from "./css-tutorial-pages/Css3MediaQueries";
// import WebDesignCssDropdowns from "./css-tutorial-pages/WebDesignCssDropdowns";
// import WebDesignCssNavigation_bar from "./css-tutorial-pages/WebDesignCssNavigationBar";
// import WebDesignCssFooter from "./css-tutorial-pages/WebDesignCssFooter";
// import WebDesignCssPagination from "./css-tutorial-pages/WebDesignCssPagination";
// import WebDesignCssBreadcrumbs from "./css-tutorial-pages/WebDesignCssBreadcrumbs";
// import WebDesignCssTooltops from "./css-tutorial-pages/WebDesignCssTooltops";
// import WebDesignCssLightbox from "./css-tutorial-pages/WebDesignCssLightbox";
// import WebDesignCssGallery from "./css-tutorial-pages/WebDesignCssGallery";
// import WebDesignCssImageSprites from "./css-tutorial-pages/WebDesignCssImageSprites";
// import WebDesignCssAccordion from "./css-tutorial-pages/WebDesignCssAccordion";
// import WebDesignCssForms from "./css-tutorial-pages/WebDesignCssForms";
// import WebDesignCssCounters from "./css-tutorial-pages/WebDesignCssCounters";
// import ResponsiveWebDesignIntroduction from "./css-tutorial-pages/ResponsiveWebDesignIntroduction";
// import ResponsiveWebDesignViewport from "./css-tutorial-pages/ResponsiveWebDesignViewport";
// import ResponsiveWebDesignGridView from "./css-tutorial-pages/ResponsiveWebDesignGridView";
// import ResponsiveWebDesignMediaQueries from "./css-tutorial-pages/ResponsiveWebDesignMediaQueries";
// import ResponsiveWebDesignImages from "./css-tutorial-pages/ResponsiveWebDesignImages";
// import ResponsiveWebDesignVideos from "./css-tutorial-pages/ResponsiveWebDesignVideos";
// import ResponsiveWebDesignFrameworks from "./css-tutorial-pages/ResponsiveWebDesignFrameworks";
// import WhatAreCssDataTypes from "./css-tutorial-pages/WhatAreCssDataTypes";
// import CssInteger from "./css-tutorial-pages/CssInteger";
// import CssNumber from "./css-tutorial-pages/CssNumber";
// import CssLength from "./css-tutorial-pages/CssLength";
// import CssPercentage from "./css-tutorial-pages/CssPercentage";
// import CssString from "./css-tutorial-pages/CssString";
// import CssColor from "./css-tutorial-pages/CssColor";
// import CssUrl from "./css-tutorial-pages/CssUrl";
// import CssAngle from "./css-tutorial-pages/CssAngle";


const App = () => {
  // const interger = `<integer>`
  //   const number = `<number>`
  //   const length = `<length>`
  //   const percentage = `<percentage>`
  //   const string = `<string>`
  //   const color = `<color>`
  //   const url = `<url>`
  //   const angle = `<angle>`
  return (
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="*" element={<Error404 />} />
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/css-tutorials/css-syntax-and-selectors" element={<CssSyntaxAndSelectors />} />
          <Route path="/css-tutorials/css-inserting" element={<CssInserting />} />
          <Route path="/css-tutorials/css-colors" element={<CssColors />} />
          <Route path="/css-tutorials/css-backgrounds" element={<CssBackgrounds />} />
          <Route path="/css-tutorials/css-borders" element={<CssBorders />} />
          <Route path="/css-tutorials/css-margins" element={<CssMargins />} />
          <Route path="/css-tutorials/css-padding" element={<CssPadding />} />
          <Route path="/css-tutorials/css-width-and-height" element={<CssWidthAndHeight />} />
          <Route path="/css-tutorials/css-box-models" element={<CssBoxModels />} />
          <Route path="/css-tutorials/css-text" element={<CssText />} />
          <Route path="/css-tutorials/css-fonts" element={<CssFonts />} />
          <Route path="/css-tutorials/css-icons" element={<CssIcons />} />
          <Route path="/css-tutorials/css-links" element={<CssLinks />} />
          <Route path="/css-tutorials/css-lists" element={<CssLists />} />
          <Route path="/css-tutorials/css-tables" element={<CssTables />} />
          <Route path="/css-tutorials/css-outline" element={<CssOutline />} />
          <Route path="/css-tutorials/css-buttons" element={<CssButtons />} />
          <Route path="/css-tutorials/css-images" element={<CssImages />} />
          <Route path="/css-tutorials/css-layout-the-display-property" element={<CssLayoutTheDisplayProperty />} />
          <Route path="/css-tutorials/css-layout-width-and-max-width" element={<CssLayoutWidthAndMaxWidth />} />
          <Route path="/css-tutorials/css-layout-positioning" element={<CssLayoutPositioning />} />
          <Route path="/css-tutorials/css-layout-overflow" element={<CssLayoutOverflow />} />
          <Route path="/css-tutorials/css-layout-float-and-clear" element={<CssLayoutFloatAndClear />} />
          <Route path="/css-tutorials/css-layout-inline-block" element={<CssLayoutInlineBlock />} />
          <Route path="/css-tutorials/css-layout-horizontal-and-vertical-align" element={<CssLayoutHorizontalAndVerticalAlign />} />
          <Route path="/css-tutorials/css-combinators" element={<CssCombinators />} />
          <Route path="/css-tutorials/css-pseudo-classes" element={<CssPseudoClasses />} />
          <Route path="/css-tutorials/css-pseudo-elements" element={<CssPseudoElements />} />
          <Route path="/css-tutorials/css-attribute-selectors" element={<CssAttributeSelectors />} />
          <Route path="/css-tutorials/css-opacity" element={<CssOpacity />} />
          <Route path="/css-tutorials/css3-introduction" element={<Css3Introduction />} />
          <Route path="/css-tutorials/css3-rounded-corners" element={<Css3RoundedCorners />} />
          <Route path="/css-tutorials/css3-border-images" element={<Css3BorderImages />} />
          <Route path="/css-tutorials/css3-colors" element={<Css3Colors />} />
          <Route path="/css-tutorials/css3-backgrounds" element={<Css3Backgrounds />} />
          <Route path="/css-tutorials/css3-gradients" element={<Css3Gradients />} />
          <Route path="/css-tutorials/css3-shadow-effects" element={<Css3ShadowEffects />} />
          <Route path="/css-tutorials/css3-text" element={<Css3Text />} />
          <Route path="/css-tutorials/css3-web-fonts" element={<Css3WebFonts />} />
          <Route path="/css-tutorials/css3-2d-transforms" element={<Css32dTransforms />} />
          <Route path="/css-tutorials/css3-3d-transforms" element={<Css33dTransforms />} />
          <Route path="/css-tutorials/css3-transitions" element={<Css3Transitions />} />
          <Route path="/css-tutorials/css3-animations" element={<Css3Animations />} />
          <Route path="/css-tutorials/css3-multiple-columns" element={<Css3MultipleColumns />} />
          <Route path="/css-tutorials/css3-user-interface" element={<Css3UserInterface />} />
          <Route path="/css-tutorials/css3-box-sizing" element={<Css3BoxSizing />} />
          {/* <Route path="/css-tutorials/css3-flexible-boxes" element={<Css3FlexibleBoxes />} />
          <Route path="/css-tutorials/css3-media-queries" element={<Css3MediaQueries />} />
          <Route path="/css-tutorials/web-design-css-dropdowns" element={<WebDesignCssDropdowns />} />
          <Route path="/css-tutorials/web-design-css-navigation-bar" element={<WebDesignCssNavigationBar />} />
          <Route path="/css-tutorials/web-design-css-footer" element={<WebDesignCssFooter />} />
          <Route path="/css-tutorials/web-design-css-pagination" element={<WebDesignCssPagination />} />
          <Route path="/css-tutorials/web-design-css-breadcrumbs" element={<WebDesignCssBreadcrumbs />} />
          <Route path="/css-tutorials/web-design-css-tooltops" element={<WebDesignCssTooltops />} />
          <Route path="/css-tutorials/web-design-css-lightbox" element={<WebDesignCssLightbox />} />
          <Route path="/css-tutorials/web-design-css-image-gallery" element={<WebDesignCssGallery />} />
          <Route path="/css-tutorials/web-design-css-image-sprites" element={<WebDesignCssImageSprites />} />
          <Route path="/css-tutorials/web-design-css-accordion" element={<WebDesignCssAccordion />} />
          <Route path="/css-tutorials/web-design-css-forms" element={<WebDesignCssForms />} />
          <Route path="/css-tutorials/web-design-css-counters" element={<WebDesignCssCounters />} />
          <Route path="/css-tutorials/responsive-web-design-introduction" element={<ResponsiveWebDesignIntroduction />} />
          <Route path="/css-tutorials/responsive-web-design-viewport" element={<ResponsiveWebDesignViewport />} />
          <Route path="/css-tutorials/responsive-web-design-grid-view" element={<ResponsiveWebDesignGridView />} />
          <Route path="/css-tutorials/responsive-web-design-media-queries" element={<ResponsiveWebDesignMediaQueries />} />
          <Route path="/css-tutorials/responsive-web-design-Images" element={<ResponsiveWebDesignImages />} />
          <Route path="/css-tutorials/responsive-web-design-videos" element={<ResponsiveWebDesignVideos />} />
          <Route path="/css-tutorials/responsive-web-design-Frameworks" element={<ResponsiveWebDesignFrameworks />} />
          <p><strong> CSS Basic DataTypes </strong></p>
          <Route path="/css-tutorials/what-are-css-data-types" element={<WhatAreCssDataTypes />} />
          <Route path="/css-tutorials/css-integer" element={<CssInteger />} />
          <Route path="/css-tutorials/css-number" element={<CssNumber />} />
          <Route path="/css-tutorials/css-length" element={<CssLength />} />
          <Route path="/css-tutorials/css-percentage" element={<CssPercentage />} />
          <Route path="/css-tutorials/css-string" element={<CssString />} />
          <Route path="/css-tutorials/css-color" element={<CssColor />} />
          <Route path="/css-tutorials/css-url" element={<CssUrl />} />
          <Route path="/css-tutorials/css-angle" element={<CssAngle />} /> */}
        </Routes>
      </BrowserRouter>
  );
};

export default App